import React from 'react';
import { Divider, Button, Header, FormInput, Accordion, AccordionContent, Icon, FormDropdown } from 'semantic-ui-react';
import ButtonsAttached from './ButtonsAttached';
import ShapefileInput from './ShapefileInput';
import HelpButton from './HelpButton';

let context = require('../mp3du_context.json');

class SimSettings extends React.Component {
	constructor(props) {
		super(props);

    // currentSim is initialized to 0 in case of existing simulations.
    // Unsure of reprocussions
    const initSim = this.props.simulations[0] === undefined ? {"PATHLINE" : {}} : this.props.simulations[0];
    this.state = {activeIndex: 0,
                  currentSim: 0,
                  localSim : initSim};
    this.updateStep = this.props.updateStep;

    this.addSim = this.addSim.bind(this);
    this.delSim = this.delSim.bind(this);
    this.chgSim = this.chgSim.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.chngSimType = this.chngSimType.bind(this);
  }

  handleUpdate(e,d) {
    const {simulations} = this.props;
    const {currentSim} = this.state;
    const simType = Object.keys(simulations[currentSim])[0]
    const target = ["SIMULATIONS", currentSim, simType, d.name];
    let value = d.value;
    if (d.type === 'int') {
      value = parseInt(value);
    }
    if (d.type === 'float') {
      value = parseFloat(value);
    }
    this.props.onChange(target, value);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.simulations[prevState.currentSim] !== prevState.localSim){
        let nextSim = prevState.currentSim;
        // If there's not enough sims
        if (prevState.currentSim > (nextProps.simulations.length - 1)) {
          nextSim = 0;
        }
        return({localSim : nextProps.simulations[nextSim],
                currentSim : nextSim});
    } else {
        return null;
    }
}

  chngSimType(e,d) {
    const simid = this.state.currentSim;
    const currObj = this.props.simulations[simid];
    const currType = Object.keys(currObj)[0];
    const newObj = { [d.value] : currObj[currType]}
    const target = ["SIMULATIONS", simid]
    this.props.onChange(target, newObj)
    this.setState({ localSim : this.props.simulations[simid]});
  }

  handleOptionsClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }

  addSim() {
    // Update Step if necessary - simulations present
    this.updateStep(3);
    // Update JSON object
    this.props.addSim();
    // Update Current Sim
    let {simulations} = this.props;
    let currentSim = simulations.length - 1;
    this.setState({ currentSim : currentSim,
                    localSim : this.props.simulations[currentSim]});
  }

  delSim() {
    // JSON object updates
    this.props.delSim(this.state.currentSim);
    // Remove simulation from the local state
    let {simulations} = this.props;
    //simulations.splice(this.state.currentSim-1, 1)
    let currentSim = Math.min(this.state.currentSim, simulations.length - 1);
    this.setState({ currentSim : currentSim });
  }

  chgSim(e) {
    // Change Current Simulation
    this.setState({currentSim : e.target.value - 1,
                   localSim : this.props.simulations[e.target.value - 1]})
  }

  listSims() {
    var sims = [];
    for (var i = 1; i <= this.props.simulations.length; i++) {
      sims.push(i);
    }
    return(
      <div className="ButtonBreak">
        <Header size='medium' floated="left">Simulation</Header>
        <ButtonsAttached labels={sims}
                         values={sims}
                         active={this.state.currentSim + 1}
                         onClick={this.chgSim}/>
      </div>
    );
  }

  getDefault(obj,name) {
    return (obj[name] === undefined) | (obj[name] === null) ? "" : obj[name];
  }

  renderSim() {
    // Initialize
    let options = this.props.options;
    //const {simulations} = this.props;
    const simType = Object.keys(this.state.localSim)[0]; //Object.keys(simulations[this.state.currentSim])[0];
    const thisSim = this.state.localSim[simType]; //simulations[this.state.currentSim][simType];
    // thisSim holds the actual options for the simulation, vs this.state.localSim which holds the object w/ simType
    const { activeIndex } = this.state;

    // Setup lists
    const directions = options.directions.map((lab,index) =>
      ({key: index, text: lab, value: lab}));
    const advoptions = options.advoptions.map((lab,index) =>
      ({key: index, text: lab, value: lab}));
    const threads = options.threads.map((lab,index) =>
      ({key: index, text: lab, value: lab}));
    
    // Set default values
    const seloptions = thisSim['OPTIONS'] === undefined ? [] : thisSim['OPTIONS'];
    
    return(
      <div>
        <ButtonsAttached labels={options.simtypes}
                         values={options.simtypes}
                         onClick={this.chngSimType}
                         active={simType}/>
        <Divider />
        <FormInput label="Simulation Name" inline className='inlineFine'
                   name="NAME" value={this.getDefault(thisSim,"NAME")}
                   onChange={this.handleUpdate}/>
        <HelpButton hint={context['SIMULATION_NAME']} />

        <Header size="small">Particle Starting Locations</Header>
        <ShapefileInput onChange={this.handleUpdate} value={thisSim['PARTICLE_START_LOCATIONS']} />
        <Divider hidden/>
        <Accordion styled>
          <Accordion.Title active={activeIndex === -1} index={0} onClick={this.handleOptionsClick}>
            <Icon name='dropdown' />Optional Settings</Accordion.Title>
          <AccordionContent active={activeIndex === -1}>
            <FormDropdown inline label="Tracking Direction" selection
                          options={directions}
                          value={this.getDefault(thisSim,'DIRECTION')}
                          name="DIRECTION" className='inlineFine'
                          onChange={this.handleUpdate}/>
            <HelpButton hint={context['SIMULATION_DIRECTION']} />
            <Divider hidden className='thinMan' />

            <FormDropdown inline label="Threads" selection name="THREAD_COUNT" type="int"
                       options={threads} compact className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,'THREAD_COUNT')}/>
            <HelpButton hint={context['THREAD_COUNT_SIMULATION']} />
            <Divider hidden className='thinMan' />

            <FormInput inline label="Adaptive Step Error" name="ADAPTIVE_STEP_ERROR" className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,"ADAPTIVE_STEP_ERROR")}/>
            <HelpButton hint={context['ADAPTIVE_STEP_ERROR']} />
            <Divider hidden className='thinMan' />

            <FormInput inline label="Inital Step Size" name="INITIAL_STEPSIZE" className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,"INITIAL_STEPSIZE")}/>
            <HelpButton hint={context['INITIAL_STEPSIZE']} />
            <Divider hidden className='thinMan' />

            <FormInput inline label="Maximum Step Size" name="MAX_STEPSIZE" className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,"MAX_STEPSIZE")}/>
            <HelpButton hint={context['MAX_STEPSIZE']} />
            <Divider hidden className='thinMan' />

            <FormInput inline label="Stagnation DT" name="STAGNATION_DT" className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,"STAGNATION_DT")}/>
            <HelpButton hint={context['STAGNATION_DT']} />
            <Divider hidden className='thinMan' />

            <FormInput inline label="Euler DT" name="EULER_DT" className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,"EULER_DT")}/>
            <HelpButton hint={context['EULER_DT']} />
            <Divider hidden className='thinMan' />

            <FormInput inline label="Simulation End Time" name="SIMULATION_END_TIME" className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,"SIMULATION_END_TIME")}/>
            <HelpButton hint={context['SIMULATION_END_TIME']} />
            <Divider hidden className='thinMan' />

            <FormInput inline label="Capture Radius" name="CAPTURE_RADIUS" className='inlineFine'
                       onChange={this.handleUpdate} value={this.getDefault(thisSim,"CAPTURE_RADIUS")}/>
            <HelpButton hint={context['CAPTURE_RADIUS']} />
            <Divider hidden className='thinMan' />

            <FormDropdown label="Options" selection multiple name="OPTIONS"
                          placeholder='Select one or more' options={advoptions}
                          onChange={this.handleUpdate} value={seloptions}/>
          </AccordionContent>
        </Accordion>
      </div>
    );
  }

  render() {
    // Step isn't used - remove from component?
    const nsim = this.props.simulations.length;
    return(
      <div>
        <Button color='teal' content='Add Simulation' icon='add' onClick={this.addSim}/>
        {nsim > 1 && <Button color='orange' content='Remove Simulation' icon='minus' onClick={this.delSim}/>}
        {nsim > 0 && this.listSims()}
        {nsim > 0 && this.renderSim()}
      </div>
    );
  }
}

export default SimSettings;